import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var paymentMethodAfterpayIcon = /*#__PURE__*/React.createElement("svg", {
  height: "35",
  width: "56",
  fill: "none",
  viewBox: "0 0 56 35",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v35H0z",
  fill: "#B2FCE4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.032 10.65-3.895-2.208-3.95-2.241c-2.612-1.484-5.876.379-5.876 3.368v.501c0 .28.146.536.394.67l1.835 1.037a.76.76 0 0 0 1.136-.658V9.926c0-.592.642-.96 1.16-.67l3.602 2.053 3.59 2.04a.761.761 0 0 1 0 1.328l-3.59 2.04-3.602 2.053a.776.776 0 0 1-1.16-.67v-.59c0-2.99-3.264-4.863-5.875-3.369l-3.94 2.253-3.894 2.208c-2.623 1.495-2.623 5.253 0 6.748l3.894 2.208 3.951 2.241c2.611 1.484 5.876-.379 5.876-3.368v-.501a.754.754 0 0 0-.394-.67l-1.835-1.037a.76.76 0 0 0-1.137.658v1.194c0 .59-.641.959-1.16.669l-3.601-2.052-3.59-2.041a.761.761 0 0 1 0-1.328l3.59-2.04 3.602-2.053a.776.776 0 0 1 1.16.67v.59c0 2.99 3.263 4.863 5.875 3.369l3.95-2.242 3.895-2.208c2.611-1.506 2.611-5.264-.011-6.758Z",
  fill: "#000"
}));

export { paymentMethodAfterpayIcon as default };
//# sourceMappingURL=paymentMethodAfterpayIcon.js.map
